import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { animate, AnimationBuilder, AnimationPlayer, style } from '@angular/animations';
import { NavigationEnd, Router } from '@angular/router';
import { filter, take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class FuseSplashScreenService
{
    splashScreenEl: any;
    player: AnimationPlayer;

    /**
     * Constructor
     *
     * @param {AnimationBuilder} _animationBuilder
     * @param _document
     * @param {Router} _router
     */
    constructor(
        private _animationBuilder: AnimationBuilder,
        @Inject(DOCUMENT) private _document: any,
        private _router: Router
    )
    {
        // Initialize
        this._init();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Initialize
     *
     * @private
     */
    private _init(): void
    {
        // Get the splash screen element
        this.splashScreenEl = this._document.body.querySelector('#fuse-splash-screen');

        // If the splash screen element exists...
        if ( this.splashScreenEl )
        {
            // Ensure initial styles are applied
            this.splashScreenEl.style.display = 'block';
            this.splashScreenEl.style.opacity = '1';
            this.splashScreenEl.style.zIndex = '99999';

            // Hide it on the first NavigationEnd event
            this._router.events
                .pipe(
                    filter((event => event instanceof NavigationEnd)),
                    take(1)
                )
                .subscribe(() => {
                        this.hide();
                });
        }
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Show the splash screen
     */
    show(): void
    {
        if (!this.splashScreenEl) {
            return;
        }

        // Stop any running animations
        if (this.player) {
            this.player.destroy();
        }

        this.splashScreenEl.style.display = 'block';
        
        this.player = this._animationBuilder
            .build([
                style({
                    opacity: '0',
                    zIndex: '99999'
                }),
                animate('200ms cubic-bezier(0.4, 0.0, 0.2, 1)', 
                    style({
                        opacity: '1'
                    })
                )
            ]).create(this.splashScreenEl);

        this.player.play();
    }

    /**
     * Hide the splash screen
     */
    hide(): void
    {
        if (!this.splashScreenEl) {
            return;
        }

        // Stop any running animations
        if (this.player) {
            this.player.destroy();
        }

        this.player = this._animationBuilder
            .build([
                style({opacity: '1'}),
                animate('200ms cubic-bezier(0.4, 0.0, 0.2, 1)', 
                    style({
                        opacity: '0',
                        zIndex: '-10'
                    })
                )
            ]).create(this.splashScreenEl);

        this.player.onDone(() => {
            this.splashScreenEl.style.display = 'none';
        });

        this.player.play();
    }
}
